import { render, staticRenderFns } from "./TrainingSwallowTest.vue?vue&type=template&id=3d0c89ad&scoped=true&"
import script from "./TrainingSwallowTest.vue?vue&type=script&lang=js&"
export * from "./TrainingSwallowTest.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSwallowTest.vue?vue&type=style&index=0&id=3d0c89ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c89ad",
  null
  
)

export default component.exports